// apps/web/src/components/organisations/OrganisationManager.tsx
// Organisation records management.

import { ManagerPage } from '../platform/ManagerPage.js';
import type { Organisation } from '../../types/platform.js';

export function OrganisationManager() {
  return (
    <ManagerPage
      title="Organisations"
      listPath="/api/v1/organisations"
      listKey="organisations"
      createLabel="New Organisation"
      className="organisations-manager"
      renderItem={(raw) => {
        const o = raw as Organisation;
        return (
          <div className="manager-card" key={o.id}>
            <h3>{o.legalName}</h3>
            <p className="status-badge">{o.status}</p>
            <p>{o.tradingName ?? 'No trading name'} · {o.countryCode ?? '—'}</p>
            <div className="actions">
              <button className="btn btn-secondary">View</button>
              <button className="btn btn-primary">Brands</button>
              <button className="btn btn-outline">Members</button>
            </div>
          </div>
        );
      }}
    />
  );
}